import { OfflineDataFetcher } from '@skinsoft/data-store/src/offline/offline-data-fetcher';

import { Item, Wemi } from '@skinsoft/entity/'
import { Observable } from 'rxjs';
import { map, pluck, tap, } from 'rxjs/operators';

export class ExpressionOfflineDataFetcher extends OfflineDataFetcher<Item>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    public fetchOneFromId(id: string): Observable<Item> {
        return super.fetchOneFromId(id)
            .pipe(
                map(obj => obj || {}),
                pluck('expression')
            )
    }

    public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }

    protected idMatcher(entity: any, id: string) {
        if (entity.expression) {
            return entity.expression.id === id;
        }
        return false;
    }

}